import { axiosSaveSite } from '../../api/admin/default';
window.footerDesign = false;
window.isFooter = 0;
window.eventFooter = false;
(function ($) {
    RVwys.plugin['Footer'] = true;
    RVwys.Footer = {};

    RVwys.uikit.blockprop.Footer = function () {
        parent.$('.wys-rowFooter').show();
    };

    $(document).bind('editorReady', function () {
        var fb = $('#frameBody').get(0).contentWindow;

        $('#back-top-wys').hide();
        if (fb.$('#back-top').attr('backtotop') > 0) {
            $('#back-top-wys').fadeIn();
        }
    });

    $(document).bind('designReady', function (e) {
        parent.$('.btn-save-footer').click(function () {
            RVwys.SaveFooter();
        });

        if (parent.$('#footer_id').val() == 0) {
            RVwys.CustomFooter();
        }

        parent
            .$('#socialSetting,.wys-footerDesignEmail #socialSetting')
            .click(function () {
                $(
                    `div[panel=".wys-rowFooterSocial"][onclick="RVwys.widget.ovewEvent(this)"],div[panel=".wys-rowFooterSocial"][onclick="RVwys.widget.ovewEvent($(this))"]`
                )
                    .first()
                    .trigger('click');
            });

        $('#textinfoFooter').click(function () {
            RVwys.Footer.ShowInfo();
        });

        parent.$('#titleInfo').keyup(function () {
            $('#titleInformation').text($(this).val());
        });

        parent.$('#contentInfo').keyup(function () {
            $('#contentInformation').text($(this).val());
        });

        parent.$('.btn-save-info').click(function () {
            $.ajax({
                type: 'POST',
                url: '/admin/wysiwyg/update/info',
                data: {
                    title: parent.$('#titleInfo').val(),
                    detail: parent.$('.contentInfo').val(),
                    _token: $('meta[name="csrf-token"]').attr('content'),
                },
                success: function (data) {
                    parent.console.pop.success({
                        text: rvLang('Save Information Success'),
                        delay: 5000,
                    });

                    parent.$('.wys-InfoFooter').hide();
                },
            });
        });

        parent.$('.btn-reset-footer').click(function () {
            var UI = parent.UIkit;

            oncancel = function () {
                modal.hide();
            };

            var onInsert = function () {
                $.ajax({
                    type: 'POST',
                    url:
                        parent.wex.url.baseUrl +
                        '/admin/wysiwyg/update/resetFooter',
                    data: {
                        slug_id: parent.$('#slug_id').val(),
                        _token: $('meta[name="csrf-token"]').attr('content'),
                    },
                    success: function (data) {
                        var idCss = $('<div/>')
                            .html(data)
                            .find('[data-footer]')
                            .data('footer');
                        $('#footerCss').attr(
                            'href',
                            parent.wex.cdn.cdnURL +
                                '/service/html/footer/css/' +
                                idCss +
                                '.css'
                        );
                        window.isFooter = 0;

                        $('#rvcmsfooter div').first().replaceWith(data);
                        RVwys.CustomFooter();
                        parent.$('.wys-footerDesign').hide();
                        parent.console.pop.success({
                            text: 'Reset Success',
                            delay: 5000,
                        });
                    },
                });

                modal.hide();
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="wys-rvdesign">',
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Reset Footer') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content"><span>' +
                        rvLang('Reset Footer to default?') +
                        '</span></div>',
                    '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Yes') +
                        '</button>',
                    '<button class="uk-button js-modal-confirm-cancel">' +
                        rvLang('No') +
                        '</button></div>',
                    '</div>',
                ].join('')
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.uk-button-success')
                .on('click', function () {
                    onInsert();
                });

            modal.show();
        });

        RVwys.Footer.setButton();
    });

    RVwys.Footer.EventFooter = function () {
        RVwys.uikit.loadFooterbannerDesign();

        parent.$('.wys-dynamic,.wys-panel,.wys-rowTwo').hide();
        parent.$('.wys-footerDesign, .panelFooter').show();

        footerDesign = true;
    };

    RVwys.uikit.loadFooterbannerDesign = function () {
        var layout = $('.design-block').attr('rv-layout');
        if (layout == 'undefined' || layout == undefined) {
            setTimeout(function () {
                RVwys.uikit.loadFooterbannerDesign();
            }, 500);
        }

        if (parent.$('#FooterAlbumUikit icon').length == '0') {
            parent
                .$('#FooterAlbumUikit')
                .html('<div class="txtSidebar">Loading...</div>');
            var urlCDN = parent.wex.cdn.cdnFooterDesign;
            var request = $.ajax({
                method: 'POST',
                url: urlCDN,
                dataType: 'html',
            });

            request.done(function (data) {
                //	    		alert(data);
                parent.$('#FooterAlbumUikit').html('');
                var oRolsFooter = $('<div/>').html(data);
                oRolsFooter.find('icon').each(function () {
                    var FooterID = oRolsFooter.find('icon').attr('footer');
                    var IconFooter = $(this);
                    parent.$('#FooterAlbumUikit').append($(this));
                    var urlCDNbyiTem =
                        parent.wex.cdn.cdnURL +
                        '/service/getdesign.php?name=footerdesign&item=' +
                        FooterID;
                    var requestbyiTem = $.ajax({
                        method: 'POST',
                        url: urlCDNbyiTem,
                        dataType: 'html',
                    });

                    requestbyiTem.done(function (data) {
                        var oRolsFooterHtml = $('<div/>').html(data);
                        var GroupSection = $('<div/>').html(
                            oRolsFooterHtml.find('div[data-footer]')
                        );
                        var widgetDefault = `
                            <div class="socailFooter uk-text-left-small">
                                <div class="blockWidget" widget="rvsitebuilder/core" widgetname="social" icon="icon_new_blank" action="/admin/core/widget/getsocialwidgetfooter" panel=".wys-rowFooterSocial">
                                    <div class="padd">
                                        <img class="imgsocial" srcs="${parent.wex.cdn.cdnURL}/templates/rvs_library/100/images/thumbnails/widget-social.png" width="200" height="22" border="0" widgetname="social" element=".socailFooter" widget="#socialbutton" data-appname="rvsitebuilder/core" />
                                    </div>
                                </div>
                            </div>`;

                        GroupSection.find('.socailFooter').replaceWith(
                            widgetDefault
                        );

                        IconFooter.find('.hvr-glow').attr(
                            'data',
                            GroupSection.html()
                        );

                        var oThisIcon = IconFooter.find('.hvr-glow');
                        RVwys.Footer.Preview(oThisIcon);
                    });
                });
            });

            request.fail(function (jqXHR, textStatus) {
                RVwys.uikit.loadFooterbannerDesign();
            });
        }
    };

    RVwys.CustomFooter = function (e) {
        var currentPage = parent.$('#cmsCurrent').text();

        var btnCustom = $(
            '<a class="uk-button uk-button-primary" id="editCustombanner" style="position: absolute;top: 0;right: 0;z-index: 10;"> Custom this banner?</a>'
        );

        console.log($('#selected_footer'));

        $('#selected_footer').addClass('rv-banner-overlay');
        $('#rvcmsfooter').prepend(
            '<figcaption id="CustomfooterFig" class="uk-overlay-panel rv-overlay-bg">' +
                '<button class="uk-button uk-button-primary btnCustomFooter uk-float-right" >' +
                '<i class="uk-icon uk-icon-wrench"></i>' +
                rvLang('Custom this footer?') +
                '</button>' +
                '<div id="keyWordCustom" class="uk-float-right custom-banner-content">' +
                rvLang('Footer in this page is Inherited from home page.') +
                '</div></figcaption>'
        );

        $('.btnCustomFooter').click(function () {
            var isTypeEmail = parent
                .$('#isType')
                .val()
                .match(/^email/)
                ? true
                : false;

            if (isTypeEmail) {
                parent.$('#footer_custom').val('1');
                RVwys.uikit.blockprop.FooterEmail();
            } else {
                window.isFooter = 1;
                RVwys.Footer.EventFooter();
            }

            $('#CustomfooterFig').remove();
            $('#selected_footer').unbind('mouseenter');
        });

        $('#selected_footer')
            .on('mouseenter', function () {
                $('#CustomfooterFig').show();
                $('#selected_footer')
                    .addClass('rv-banner-overlay-hover')
                    .removeClass('rv-banner-overlay');
                $('#selected_footer').css({
                    position: 'relative',
                });
            })
            .mouseleave(function () {
                $('#selected_footer')
                    .addClass('rv-banner-overlay')
                    .removeClass('rv-banner-overlay-hover');
            });
    };

    RVwys.Footer.Preview = function (oThisIcon) {
        //		SaveFooter();
        var dataFooter = $('#selected_footer .mg').first().clone();
        var idCssOld = $('#footerCss').attr('href').match(/\d+/);
        var CssOld = $('#footerCss').attr('href');
        var oldPowered = dataFooter.find('powered').html();
        var oldCopyright = dataFooter.find('#copyrightFooter').html();
        var oldSitemap = dataFooter.find('#sitemapFooter').html();

        var oldTitleContact = dataFooter.find('#titleContact').html();
        var oldTel = dataFooter.find('#liPhoneFooter').html();
        var oldEmail = dataFooter.find('#liEmailFooter').html();
        var oldAddress = dataFooter.find('#liAddressFooter').html();
        var oldTitleInfo = dataFooter.find('#titleInformation').html();
        var oldContentInfo = dataFooter.find('#contentInformation').html();
        var overlaypanel = $('<div class="overlayfooter"></div>').css({
            'background-color': 'red',
            opacity: '0',
            position: 'absolute',
            left: '0',
            top: '0',
            width: $('body').width(),
            height: $('body').height(),
        });

        if (!parent.$('.overlayfooter').get(0)) {
            parent.$('body').prepend(overlaypanel);
        }

        parent.$('.overlayfooter').click(function () {
            if (window.eventFooter) {
                $('#selected_footer .mg').first().replaceWith(dataFooter);
                $('#footerCss').attr('href', CssOld);
                window.eventFooter = false;
            }

            parent.$('.wys-footerDesign,.wys-footerDesignEmail').hide();
            parent.$('.overlayfooter').remove();
        });

        oThisIcon.click(function (e) {
            window.eventFooter = true;
            var idFooter = $(this).closest('icon').attr('footer');
            var dataElm = $(this).attr('data');
            var selector = $(dataElm).find('.blockWidget');

            //			Footer style
            $('#footerCss').attr(
                'href',
                parent.wex.cdn.cdnURL +
                    '/service/html/footer/css/' +
                    idFooter +
                    '.css'
            );

            var Footer = $('<div>').html(dataElm);
            Footer.find('#powered').html(oldPowered);
            Footer.find('#copyrightFooter').html(oldCopyright);
            Footer.find('#sitemapFooter').html(oldSitemap);

            Footer.find('#titleContact').html(oldTitleContact);
            Footer.find('#liPhoneFooter').html(oldTel);
            Footer.find('#liAddressFooter').html(oldAddress);
            Footer.find('#liEmailFooter').html(oldEmail);

            Footer.find('#titleInformation').html(oldTitleInfo);
            Footer.find('#contentInformation').html(oldContentInfo);

            var eleFooter = $('#selected_footer .mg>div').get(0)
                ? $('#selected_footer .mg>div')
                : $('#selected_footer #rvcmsfooter>div');

            eleFooter.replaceWith(Footer.html());
            RVwys.widget.elementReceive(dataElm, e, selector);
            RVwys.regisSection(e, $('#selected_footer .mg'));

            $('#selected_footer #contactListFooter').click(function () {
                RVwys.uikit.blockprop.Brand();
            });

            $('#selected_footer #textinfoFooter').click(function () {
                RVwys.Footer.ShowInfo();
            });
        });
    };

    RVwys.Footer.setButton = function () {
        if (!$('#sitemapFooter').hasClass('uk-footer-displayNone')) {
            parent.$('#sitemap_onoff').prop('checked', true).trigger('change');
        }

        parent.$('#sitemap_onoff').change(function () {
            if (this.checked) {
                $('#sitemapFooter')
                    .removeClass('uk-footer-displayNone')
                    .addClass('uk-footer-displayShow');
            } else {
                $('#sitemapFooter')
                    .removeClass('uk-footer-displayShow')
                    .addClass('uk-footer-displayNone');
            }
        });

        if (!$('#copyrightFooter').hasClass('uk-footer-displayNone')) {
            parent
                .$('#copyright_onoff')
                .prop('checked', true)
                .trigger('change');
        }

        parent.$('#copyright_onoff').change(function () {
            if (this.checked) {
                $('#copyrightFooter')
                    .removeClass('uk-footer-displayNone')
                    .addClass('uk-footer-displayShow');
            } else {
                $('#copyrightFooter')
                    .removeClass('uk-footer-displayShow')
                    .addClass('uk-footer-displayNone');
            }
        });

        parent.$('#off_powered').click(function () {
            $('#poweredFooter')
                .removeClass('uk-footer-displayShow')
                .addClass('uk-footer-displayNone');
        });

        parent.$('#on_powered').click(function () {
            $('#poweredFooter')
                .removeClass('uk-footer-displayNone')
                .addClass('uk-footer-displayShow');
        });
    };

    RVwys.Footer.ShowInfo = function () {
        parent.$('.wys-dynamic,.wys-panel,.wys-rowTwo').hide();
        parent.$('.wys-InfoFooter, .panelFooter').show();

        RVwys.Footer.SetInfo();
    };

    RVwys.Footer.SetInfo = function () {
        parent.$('#titleInfo').val($('#titleInformation').text());
        parent.$('.contentInfo').val($('#contentInformation').text());
    };

    RVwys.SaveFooter = function () {
        var fb = parent.$('#frameBody').get(0).contentWindow;
        var slug_id =
            $('#slug_id').length == 1
                ? $('#slug_id').val()
                : parent.$('#slug_id').val();
        var idCss = fb
            .$('#footerCss')
            .attr('href')
            .match(/css\/(\d+)/);

        idCss = idCss != null ? idCss[1] : '';

        var footer_content =
            $('#selected_footer').length == 1
                ? $('#selected_footer .mg').clone()
                : fb.$('#selected_footer .mg').clone();

        var footer_edit = RVwys.save.removeEle.contentFooter(footer_content);
        footer_edit = RVwys.save.replaceEle.contentFooter(footer_edit);
        footer_edit = RVwys.save.replaceTxt.contentFooter(footer_edit);

        var footer_view = RVwys.save.removeEle.contentFooterView(
            footer_content
        );
        footer_view = RVwys.save.replaceEle.contentFooterView(footer_view);
        footer_view = RVwys.save.replaceTxt.contentFooterView(footer_view);

        footer_edit = RVwys.save.encodeHTMLentities(footer_edit);
        footer_view = RVwys.save.encodeHTMLentities(footer_view);

        var isMasterFooterVal = $('#isMasterFooter').val();

        // API Axios axiosSaveSite
        axiosSaveSite({
            savetype: 'footer',
            isMasterFooter: isMasterFooterVal,
            isCustomFooter: window.isFooter,
            footerStyle: idCss,
            slug_id: slug_id,
            footer_content_edit: footer_edit,
            footer_content_view: footer_view,
        }).then(result => {
            parent.console.pop[result.data.footer.status]({
                text: data.footer.response_msg,
                delay: 5000,
            });

            parent.$('.overlayfooter').remove();
        });
    };

    RVwys.EventCustomFooter = function () {
        if (parent.$('#footer_id').val() == '1') {
            parent.$('.btn-reset-footerEmail').hide();
        }

        var footerCustom =
            parent.$('#isType').val() == 'email'
                ? parent.$('#footer_custom').val()
                : window.isFooter;

        if (parent.$('#footer_id').val() == '0' && footerCustom == '') {
            var UI = parent.UIkit;
            oncancel = function () {
                modal.hide();
            };

            var onInsert = function (e) {
                $('.btnCustomFooter').trigger('click');
                modal.hide();
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="wys-rvemail">',
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Custom Footer') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        rvLang(
                            'Footer in this page is Inherited from home page.'
                        ) +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Custom this banner?') +
                        '</button>',
                    '<button class="uk-button js-modal-confirm-cancel">Cancel</button>',
                    '</div>',
                    '</div>',
                ].join('')
            );
            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.uk-button-success')
                .on('click', function () {
                    onInsert();
                });

            modal.show();
        } else {
            var isTypeEmail = parent
                .$('#isType')
                .val()
                .match(/^email/)
                ? true
                : false;

            if (isTypeEmail) {
                parent.$('#footer_custom').val('1');
                RVwys.uikit.blockprop.FooterEmail();
            } else {
                window.isFooter = 1;
                RVwys.Footer.EventFooter();
            }
        }
    };

    RVwys.designViewAddEvent('mousedown', function (e) {
        parent.$('.wys-InfoFooter').hide();
    });
})(jQuery);
